import { render, staticRenderFns } from "./AgencySetupGuide.vue?vue&type=template&id=19827f2b&scoped=true"
import script from "./AgencySetupGuide.vue?vue&type=script&lang=js"
export * from "./AgencySetupGuide.vue?vue&type=script&lang=js"
import style0 from "./AgencySetupGuide.vue?vue&type=style&index=0&id=19827f2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19827f2b",
  null
  
)

export default component.exports